import translations from "./modules/translations/store";
import workLists from "./modules/workLists/store";
import pills from "./modules/pills/store";
import order from "./modules/order/store";
import user from "./modules/user/store";
import medKey from "./modules/medKey/store";

export default {
  modules: {
    translations,
    workLists,
    pills,
    order,
    user,
    medKey
  }
};
